import React from 'react';
import { useIntl } from 'react-intl';
import { MdConstruction } from 'react-icons/md';
import type { UserAppDraft } from '@api/appBuilder';
import { userAppStatusLabel } from './userAppStatus';
import { Badge, Status } from './BuilderModeBadge.styled';

interface BuilderModeBadgeProps {
  readonly draft: UserAppDraft;
  readonly compact: boolean;
}

const BuilderModeBadge: React.FC<BuilderModeBadgeProps> = ({ draft, compact }) => {
  const intl = useIntl();
  const mode = intl.formatMessage({ id: 'apps.builder.mode', defaultMessage: 'Builder mode' });
  const status = userAppStatusLabel(intl, draft);
  return (
    <Badge $compact={compact} aria-label={compact ? `${mode} · ${status}` : undefined} role={compact ? 'img' : undefined}>
      <MdConstruction size={14} aria-hidden="true" />
      {!compact && <span>{mode}</span>}
      <Status $hidden={compact} data-testid="app-builder__status">
        {status}
      </Status>
    </Badge>
  );
};

export default BuilderModeBadge;
